import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Box, Button, Stack, FormGroup, FormControlLabel, FormControl, Checkbox as MUICheckbox } from "@mui/material";
import { GoogleMaterialIcon } from "../../ui/GoogleMaterialIcon";
import { useNavigate } from "react-router-dom";
import CustomerContext from "../../../context/customer/CustomerContext";
import AuthContext from "../../../context/auth/AuthContext";
import ClientFilingMasterContext from "../../../context/client-filing-master/ClientFilingMasterContext";
import FilingMasterContext from "../../../context/filing-master/FilingMasterContext";
import CustomDialog from "../../common/CustomDialog";
import Loader from "../../common/Loader";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { capitalizeLeadingText } from "../../../utils/textFormat";
import { ScrollPanel } from "primereact/scrollpanel";
import { OverlayPanel } from "primereact/overlaypanel";
import { DateTime } from "luxon";
import { Dropdown } from "primereact/dropdown";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import states from "../../../data/StateLookup.json"
import axios from "axios";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { tokens } from "../../../theme/tokens";
import { useResponsive } from "../../hooks/useResponsive";
import ClientTableFilter from "../../customer/ClientTableFilter";
import { useCommonDetailsContext } from "../../../context/Common/common";
import { TrackNowButton } from "../../ui/TrackNowButton";

const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

// const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;

const AddFilingTable = (props) => {
  const { publishedBranding, clientScopedBranding, validateParentData } = useCommonDetailsContext();
  const activeBranding = validateParentData?.isSingleParent ? publishedBranding : (clientScopedBranding || publishedBranding);
  const primaryColor = activeBranding?.primaryColor || tokens.colors.connectedPurple;
  const { isMobile, mdUp } = useResponsive();
  const enableForzen = !isMobile
  let { clientId } = useParams();
  // const [checked, setChecked] = useState(false);
  // const [FilingMasterList, setMasterFilingList] = useState([]);
  const [_clientId, setClientId] = useState(clientId);
  const [updatedFilingMasterList, setUpdatedFilingMasterList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedMasters, setSelectedMasters] = useState(null);
  const [expandedRows, setExpandedRows] = useState(null);
  const [masterTypeVal, setMasterTypeVal] = useState(false);
  const [clientTypeVal, setClientTypeVal] = useState(false);
  const [isFilingTypeChanged, setIsFilingTypeChanged] = useState(false);
  const [isFilingTypeDisabled, setIsFilingTypeDisabled] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [masterCatFilter, setMasterCatFilter] = useState([]);
  const [stateArray, setStateArray] = useState([]);
  const [selectRows, setSelectRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sortMaster, setSortMaster] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [sortRecord, setSortRecord] = useState("Upcoming Due Dates");
  const [rowClick, setRowClick] = useState(true);
  const [categoryList, setCategoryList] = useState([])
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);

  const [lazyLoading, setLazyLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [currentWindowStart, setCurrentWindowStart] = useState(0);

  // Lazy loading refs
  const filingsLengthRef = useRef(0);
  const totalRecordsRef = useRef(0);
  const lazyLoadingRef = useRef(false);
  const hasMoreDataRef = useRef(true);
  const initialLoadRef = useRef(false);
  const prevFilterRef = useRef([]);
  const prevSortRef = useRef({ sortBy: "", sortOrder: "" });
  const windowStartRef = useRef(0);
  const lastScrollDirectionRef = useRef(null);
  const overlayRefs = useRef({});

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    filingName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // filingId: { value: null, matchMode: FilterMatchMode.CONTAINS },
    // filingDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
    filingFrequency: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // dueDayofFrequency: { value: null, matchMode: FilterMatchMode.IN },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    ruleInfo: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    required: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    federalCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateCategories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    // jsidept: { value: null, matchMode: FilterMatchMode.CONTAINS },
    jsicontactName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // jsiContactEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
  });
  const navigate = useNavigate();
  const customerContext = useContext(CustomerContext);
  const clientFilingMasterContext = useContext(ClientFilingMasterContext);
  const { selectedCustomer } = customerContext;
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [selectedPeriods, setSelectedPeriods] = useState([]);
  // const [showAlertMessage, setShowAlertMessage] = React.useState(false);
  const {
    getClientFilingMastersForAdd,
    ClientFilingMastersAdd,
    ClientFilingMasterLoaded,
    addClientFilingMaster,
  } = clientFilingMasterContext;

  const filingMasterContext = useContext(FilingMasterContext);
  const { getBusinessCategories } = filingMasterContext;

  const authContext = useContext(AuthContext);
  const {
    authUser,
    isAuthenticated,
    roleType,
    getCustomerNotifications,
    getFilingNotifications,
    getCustomerNotificationsWorkFlow,
    setNotificationCount,
    getAllNotificationCount,
    token,
  } = authContext;
  const [customerNotificationCount, setCustomerNotificationCount] =
    React.useState(0);
  const [filingNotificationCount, setFilingNotificationCount] =
    React.useState(0);
  const [customerNotificationsWorkFlow, setCustomerNotificationsWorkFlow] =
    React.useState(0);

  const allowedFilterColumns = [
    "filingName",
    "filingFrequency",
    "stateList",
    "ruleInfo",
    "federalCategories",
    "stateCategories",
    "juristiction",
    "required",
    "jsicontactName",
  ];

  const submitDialog = () => {
    // closeConfirm();
    //Storing only the selected row of slected filing periods 
    const selectedPeriodsList = Array.isArray(selectedPeriods) ? selectedPeriods : [];
    const filingPeriodsList = Array.isArray(selectedMasters?.filingPeriods)
      ? selectedMasters.filingPeriods
      : [];
    const filtPeriods = selectedPeriodsList.filter((period) =>
      filingPeriodsList.some((item) => item.periodId === period.periodId)
    );
    console.log("submitDialog", "filtPeriods", filtPeriods);
    if (filtPeriods.length === 0) {
      setDialogTitle("Info");
      setDialogMessage("Please select periods for submit");
      setOpenDialog(true);
      return;
    } else {
      setSelectedPeriods(filtPeriods)
      console.log("submitDialog", "selectedMaster", selectedMasters, "selectedPeriods", selectedPeriods);
      if (selectedMasters.isRejected) {
        setAlertMessage("Do you want to submit this filing for approval?");
      } else {
        setAlertMessage("Do you want to submit the filing with selected periods?")
      };
      setShowAlert(true);
    }
  };

  const fetchNotificationCount = async () => {


    if (
      getAllNotificationCount
    ) {
      try {
        if (token) {
          const res = await getAllNotificationCount(token, authUser?.userId);
          console.log("fetchNotifications", res);

          if (setNotificationCount) {
            setNotificationCount(res.totalCount);
          }
        }
      } catch (error) {
        console.log('@@Error:', error);
      }
    }
  };

  const submitHandler = async () => {
    console.log("AuthUSer....", authUser);
    setShowAlert(false);
    setIsLoading(true);
    const payLoad = selectedPeriods.map((period) => ({
      periodId: period?.periodId,
      customerId: clientId,
      filingId: selectedMasters.filingId,
      createDate: new Date(),
      createUser: authUser.userId + "",
      updateDate: new Date(),
      updateUser: authUser.userId + "",
      businessOperation: "add",
      status: "Pending",
    }))

    try {
      if (addClientFilingMaster) {
        const res = await addClientFilingMaster(payLoad);
        console.log("Result....", res);

        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        setMasterCatFilter([]);
        await resetTableAndReload();

        if (selectedMasters.isRejected) {
          setDialogMessage("Successfully submitted filings for approval");
        } else {
          setDialogMessage("Successfully submitted and approved the Client Filing. Please check the filing in Tracker page.");
        }
        setDialogTitle("Success");
        setOpenDialog(true);

        setSelectedMasters(null);
        setSelectedPeriods([])
        await fetchNotificationCount();
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setDialogTitle("Error");
      setDialogMessage("Unexpected Error Occurred");
      setOpenDialog(true);
      console.log("Setting Alert to =>", `Unexpected Error Occured`, error);
    }
  };

  const fetchClientFilingMasters = async (clientId) => {
    console.log("@@Fetch Cust Filing Master:", clientId);
    // if (clientId) {
    // setIsLoading(true);
    // console.log("fetchClientFilingMasters ", masterTypeVal, clientTypeVal);
    let filingType
    if (clientTypeVal !== masterTypeVal && !isFilingTypeDisabled) {
      filingType = clientTypeVal ? "ClientFiling" : "MasterFiling"
    }

    let payLoad = { customerId: clientId };
    if (getClientFilingMastersForAdd) {
      console.log("@@Fetch Cust Filing Master:");
      try {
        const custList = await getClientFilingMastersForAdd(payLoad, filingType ? filingType : null);
        console.log("@@Cust Filing Master:", custList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
    // }
  };

  const onRowSelect = (e) => {
    setSelectRows(e);
    console.log("@@RowSelect:", e);
    console.log("@@", selectRows);
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const handleChange = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    console.log("state", selectedRows);
    props.setLoadingFlag(isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("state", selectedRows);
  }, [selectedRows]);

  useEffect(() => {
    console.log("####ClientID param", _clientId, clientId);
    if (_clientId !== undefined && _clientId !== null && clientId !== "" && clientId !== _clientId) {
      setSelectedMasters(null);
      setIsLoading(true);
      setUpdatedFilingMasterList([]);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setMasterCatFilter([]);
      setGlobalFilterValue('');
      setIsClearIcon(false)
      setFilters({
        ...filters,
        global: {
          ...filters.global,
          value: null,
        },
      });
      search.current.value = ""
      filingsLengthRef.current = 0;
      hasMoreDataRef.current = true;
      lazyLoadingRef.current = false;
    } else {
      setUpdatedFilingMasterList([])
      setSelectedMasters(null);
      setIsFilterChange([]);
      setSortingData({ sortBy: "", sortOrder: "" });
      setGlobalFilterValue('');
      setIsClearIcon(false)
      setFilters({
        ...filters,
        global: {
          ...filters.global,
          value: null,
        },
      });
      search.current.value = ""
    }
  }, [_clientId]);

  useEffect(() => {
    console.log("####ClientID param", _clientId, isFilingTypeChanged, clientId);
    if (isFilingTypeChanged && _clientId !== undefined && clientId !== "") {
      if (masterTypeVal === false && clientTypeVal === false) {
        setUpdatedFilingMasterList([])
        setIsFilingTypeChanged(false)
      } else {
        console.log("#### CHECK 2", _clientId, clientId);
        setIsLoading(true);
        setUpdatedFilingMasterList([]);
        setIsFilterChange([]);
        setSortingData({ sortBy: "", sortOrder: "" });
        setMasterCatFilter([]);
        filingsLengthRef.current = 0;
        hasMoreDataRef.current = true;
        lazyLoadingRef.current = false;
        loadRecordsList(0, 100);
      }
      setSelectedMasters(null);
    }
  }, [isFilingTypeChanged]);

  useEffect(() => {
    if (selectedCustomer) {
      // fetchClientFilingMasters(selectedCustomer.customerId);
      // console.log("####Setting ClientID state", selectedCustomer.customerId);
      // setClientId(() => selectedCustomer.customerId);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    console.log("####ClientID param props", props.selectedClientId);
    if (props.selectedClientId) {
      setClientId(props.selectedClientId);
      setClientTypeVal(false);
      setMasterTypeVal(false);

      const loadInitialData = async () => {
        setIsLoading(true);
        setUpdatedFilingMasterList([]);
        setTotalRecords(0);
        filingsLengthRef.current = 0;
        hasMoreDataRef.current = true;
        initialLoadRef.current = true;

        try {
          const url = `${API_BASE_URL}/Customer/BusinessBasedFilingMasterListbyPagination?StartRow=1&EndRow=100&CustomerId=${props.selectedClientId}`;
          console.log("Initial API call URL:", url);

          const res = await axios.get(url);
          console.log("Initial API response:", res.data);

          if (res.data && res.data.items) {
            const filteredItems = applyRequiredFilterOnRows(res.data.items);
            const updList = filteredItems
              .map((item) => mapDeferredRecordForDisplay(item))
              .filter(Boolean);

            setUpdatedFilingMasterList(updList);
            setTotalRecords(res.data.totalItems);
            totalRecordsRef.current = res.data.totalItems;
            filingsLengthRef.current = updList.length;
            hasMoreDataRef.current = updList.length < res.data.totalItems;
            setCurrentWindowStart(0);
            windowStartRef.current = 0;

            setClientTypeVal(res.data.isClientFile || false);
            setMasterTypeVal(res.data.isMasterFile || false);
            setIsFilingTypeDisabled(!(res.data.isClientFile && res.data.isMasterFile));
          }
        } catch (error) {
          console.error("Error loading initial data:", error);
        } finally {
          setIsLoading(false);
        }
      };

      loadInitialData();
    }
  }, [props.selectedClientId]);

  // useEffect(() => {
  //   // if (clientId) setSelectedClient((old) => clientId);
  //   if (!clientId && !selectedClient) {
  //     fetchClientFilingMasters();
  //   }
  //   //eslint-disable-next-line
  // }, []);

  useEffect(() => {
    if (ClientFilingMastersAdd) {
      // console.log("Orig Filing List...", ClientFilingMastersAdd);
      // const updList =
      //   ClientFilingMastersAdd.deferredList ?
      //     ClientFilingMastersAdd.deferredList.map((item) => {
      //       console.log(`Customer filing M...`, item);

      //       if (item.juristiction?.includes("Federal")) {
      //         const categories = _.map(
      //           item.businessCategory,
      //           "businessCategoryName"
      //         ).join(", ");
      //         console.log(`Customers ${item.filingId} cat...`, categories);
      //         return { ...item, federalCategories: categories };
      //       } else {
      //         console.log(
      //           "stateCategories: props",
      //           item.stateInfo,
      //           item.businessCategory
      //         );
      //         const categoriesState = item.businessCategory.filter((ele) =>
      //           ele.state ? ele.state === item.stateInfo : ele
      //         );
      //         console.log(
      //           "stateCategories: filter",
      //           item.filingName,
      //           categoriesState
      //         );
      //         const categories = categoriesState
      //           .map((ele) => ele.businessCategoryName)
      //           .join(", ");

      //         console.log(`filingMasters ${item.filingMasters} cat...`, categories);

      //         return { ...item, stateCategories: categories };
      //       }
      //     })
      //     : [];
      // // console.log("Updated Customers filing M...", updList);
      // if (clientTypeVal === masterTypeVal) {
      //   setClientTypeVal(ClientFilingMastersAdd.isClientFile)
      //   setMasterTypeVal(ClientFilingMastersAdd.isMasterFile)
      //   if (ClientFilingMastersAdd.isClientFile === true && ClientFilingMastersAdd.isMasterFile === true) {
      //     setIsFilingTypeDisabled(false)
      //   } else {
      //     setIsFilingTypeDisabled(true)
      //   }
      // }
      // setIsFilingTypeChanged(false)
      // // setData(updCustomers);
      // setUpdatedFilingMasterList(updList);
      // setIsLoading(false);
    }

    //eslint-disable-next-line
  }, [ClientFilingMastersAdd]);

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let list = []
        const resList = await getBusinessCategories();
        console.log("@@BusinessCategories:", resList);
        list = resList.map((item) => item.businessCategoryName).sort()
        console.log("@@BusinessCategories: list", list);
        setCategoryList(() => list);
        return
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };


  useEffect(() => {
    // getClientFilingMastersForAdd({ clientId: 0 });
    fetchBusinessCategories()
    let list = states.map((ele) => ele.state);
    setStateArray(list);
  }, []);

  useEffect(() => {
    if (authUser && authUser?.userId) fetchNotificationCount();
  }, [authUser]);

  const closeAlert = () => {
    setShowAlert(() => false);
    setAlertMessage("")
  };

  const handleFilingTypeChange = (type) => {
    console.log("handleFilingTypeChange", type);
    setIsFilingTypeChanged(true)
    if (type === "master") {
      setMasterTypeVal(!masterTypeVal)
    } else {
      setClientTypeVal(!clientTypeVal)
    }
  };

  const search = useRef()

  const applyGlobalFilter = (e) => {
    let _filters = { ...filters };
    if (filters.global.value === null) {
      _filters["global"].value = search.current.value;
      setIsClearIcon(true);
    } else {
      _filters["global"].value = null;
      search.current.value = ""
      setIsClearIcon(false);
    }
    setFilters(_filters);
    onFilterChange({ filters: _filters });
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const normalizeRequiredFilterValue = (value) => {
    const rawValue = Array.isArray(value) ? value[0] : value;
    if (typeof rawValue === "boolean") {
      return rawValue;
    }
    if (typeof rawValue === "string") {
      const normalized = rawValue.trim().toLowerCase();
      if (normalized === "true") return true;
      if (normalized === "false") return false;
    }
    return rawValue;
  };

  const normalizeRequiredRecordValue = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") {
      if (value === 1) return true;
      if (value === 0) return false;
    }
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "1") return true;
      if (normalized === "false" || normalized === "0") return false;
    }
    return null;
  };

  const toCategoryNames = (categoryItems) => {
    const uniqueNames = Array.from(
      new Set(
        (categoryItems || [])
          .map((item) =>
            typeof item === "string" ? item : item?.businessCategoryName
          )
          .filter(Boolean)
      )
    );
    return uniqueNames.join(", ");
  };

  const mapDeferredRecordForDisplay = (item) => {
    if (!item || typeof item !== "object") {
      return null;
    }

    const _stateList = getStateName(item?.stateInfo);
    const businessCategories = Array.isArray(item?.businessCategory)
      ? item.businessCategory
      : [];
    const jurisdiction = String(item?.juristiction || "").toLowerCase();
    const hasFederal = jurisdiction.includes("federal") || jurisdiction.includes("both");
    const hasState = jurisdiction.includes("state") || jurisdiction.includes("both");

    const allCategoryNames = toCategoryNames(businessCategories);
    const stateSpecificCategoryNames = toCategoryNames(
      businessCategories.filter((entry) => {
        const entryState = entry?.state;
        if (!entryState) return true;
        return (
          String(entryState).toLowerCase() ===
          String(item?.stateInfo || "").toLowerCase()
        );
      })
    );
    const resolvedStateCategoryNames = stateSpecificCategoryNames || allCategoryNames;

    if (hasFederal && hasState) {
      return {
        ...item,
        federalCategories: allCategoryNames,
        stateCategories: resolvedStateCategoryNames,
        stateList: _stateList,
      };
    }

    if (hasFederal) {
      return {
        ...item,
        federalCategories: allCategoryNames,
        stateList: _stateList,
      };
    }

    if (hasState) {
      return {
        ...item,
        stateCategories: resolvedStateCategoryNames,
        stateList: _stateList,
      };
    }

    return {
      ...item,
      federalCategories: allCategoryNames,
      stateCategories: resolvedStateCategoryNames,
      stateList: _stateList,
    };
  };

  const applyRequiredFilterOnRows = (rows) => {
    const requiredFilter = (isFilterChange || []).find(
      (item) => item.name === "SearchByRequired"
    );

    if (!requiredFilter) {
      return rows;
    }

    const expectedValue = normalizeRequiredFilterValue(requiredFilter.val);
    if (typeof expectedValue !== "boolean") {
      return rows;
    }

    return (rows || []).filter((item) => {
      const rowValue = normalizeRequiredRecordValue(item?.required);
      return rowValue === expectedValue;
    });
  };

  const formatFilterLabel = (field) => {
    const labelMap = {
      filingName: "Filing Name",
      filingFrequency: "Filing Frequency",
      stateList: "State",
      ruleInfo: "Rule Info",
      federalCategories: "Who Must File Federal",
      stateCategories: "Who Must File In State",
      juristiction: "Jurisdiction",
      required: "Required",
      jsicontactName: "JSI Staff",
    };

    if (labelMap[field]) return labelMap[field];

    return String(field || "")
      .replace(/[_-]+/g, " ")
      .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const formatFilterValue = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => formatFilterValue(item)).join(", ");
    }
    if (value === true) return "True";
    if (value === false) return "False";
    return value;
  };

  const formatFilterCondition = (filter) => {
    const conditionMap = {
      contains: "Contains",
      in: "Contains",
      equals: "Is",
      notContains: "Is Not",
      dateIs: "Date Is",
      dateIsNot: "Date Is Not",
      dateBefore: "Date Before",
      dateAfter: "Date After",
    };

    const rawCondition =
      filter?.matchModeLabel ||
      conditionMap[filter?.matchMode] ||
      "Is";

    return String(rawCondition)
      .split(" ")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleFilterApply = (filterConfig) => {
    if (!allowedFilterColumns.includes(filterConfig.field)) {
      return;
    }

    const isRequiredField = filterConfig.field === "required";
    const normalizedValue = isRequiredField
      ? normalizeRequiredFilterValue(filterConfig.value)
      : filterConfig.value;
    const normalizedMatchMode = isRequiredField
      ? FilterMatchMode.EQUALS
      : filterConfig.matchMode;

    const newFilter = {
      ...filterConfig,
      value: normalizedValue,
      matchMode: normalizedMatchMode,
      id: Date.now(),
    };
    setActiveFilters((prev) => [
      ...prev.filter((item) => item.field !== filterConfig.field),
      newFilter,
    ]);

    let _filters = { ...filters };
    if (filterConfig.field && _filters[filterConfig.field]) {
      _filters[filterConfig.field].constraints[0].value = normalizedValue;
      _filters[filterConfig.field].constraints[0].matchMode =
        normalizedMatchMode;
      setFilters(_filters);
      onFilterChange({ filters: _filters });
    }
  };

  const resetTableAndReload = async () => {
    setUpdatedFilingMasterList([]);
    setIsLoading(true);
    filingsLengthRef.current = 0;
    hasMoreDataRef.current = true;
    lazyLoadingRef.current = false;
    windowStartRef.current = 0;
    setCurrentWindowStart(0);
    await loadRecordsList(0, 100);
  };

  const handleFilterClear = async () => {
    setActiveFilters([]);

    let _filters = { ...filters };
    if (_filters.global) _filters.global.value = null;

    allowedFilterColumns.forEach((field) => {
      if (_filters[field]?.constraints?.[0]) {
        _filters[field].constraints[0].value = null;
      }
    });

    setFilters(_filters);
    setIsFilterChange([]);
    setSortingData({ sortBy: "", sortOrder: "" });

    if (search?.current) {
      search.current.value = "";
    }
    setIsClearIcon(false);

    await resetTableAndReload();
  };

  const removeFilter = (filterId) => {
    const filterToRemove = activeFilters.find((f) => f.id === filterId);
    setActiveFilters((prev) => prev.filter((f) => f.id !== filterId));

    if (filterToRemove) {
      let _filters = { ...filters };
      if (filterToRemove.field && _filters[filterToRemove.field]) {
        _filters[filterToRemove.field].constraints[0].value = null;
        setFilters(_filters);
        onFilterChange({ filters: _filters });
      }
    }
  };

  const renderHeader = () => {
    return (
      <Grid container spacing={1} sx={{ mb: 2, background: tokens.colors.offWhite, p: 2, px: 2, borderRadius: "8px" }}>
        <Grid xs={12} sx={{ display: "flex", alignItems: "center", gap: 1, pl: 2, mb: 1 }}>
          <Typography
            variant='h6'
            noWrap
            component='div'
            sx={{
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: 1
            }}
          >
            DEFERRED FILINGS ({totalRecords})
          </Typography>
        </Grid>
        <Grid
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            flexDirection: { xs: "column", md: "row" },
            gap: 2
          }}
        >
          <Grid
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flex: 1,
              minWidth: 0,
              pr: { md: 2 }
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={handleFilterClick}
            >
              + Filter
            </TrackNowButton>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              width: { xs: "100%", sm: "auto" },
              flexShrink: 0
            }}
          >
            <Grid sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <FormControlLabel
                control={
                  <MUICheckbox
                    checked={masterTypeVal}
                    disabled={isFilingTypeDisabled}
                    onClick={() => handleFilingTypeChange("master")}
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: masterTypeVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>Master Filing</span>}
                sx={{ margin: 0 }}
              />
              <FormControlLabel
                control={
                  <MUICheckbox
                    checked={clientTypeVal}
                    disabled={isFilingTypeDisabled}
                    onClick={() => handleFilingTypeChange("client")}
                    sx={{
                      color: primaryColor,
                      '&.Mui-checked': { color: primaryColor },
                      padding: '4px'
                    }}
                  />
                }
                label={<span style={{ color: clientTypeVal ? "#4a4a4a" : "#9ca3af", fontWeight: 500, fontSize: '15px' }}>Client Filing</span>}
                sx={{ margin: 0 }}
              />
            </Grid>
            <TextField
              inputRef={search}
              placeholder="Search Filing Name..."
              size="small"
              sx={{
                width: { xs: "100%", sm: 280 },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "999px",
                  backgroundColor: tokens.colors.offWhite,
                  fontFamily: "Area Normal, Inter, sans-serif",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${primaryColor} !important`,
                    borderWidth: "1px !important",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: `${primaryColor} !important`,
                    borderWidth: "1px !important",
                  },
                },
                "& .MuiInputBase-input": {
                  py: "11px",
                  px: "14px",
                  fontSize: "15px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} edge="end" size="small">
                      {isClearIcon ? (
                        <ClearIcon sx={{ color: primaryColor }} />
                      ) : (
                        <SearchIcon sx={{ color: primaryColor }} />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={submitDialog}
              disabled={!selectedMasters?.filingId}
            >
              Submit
            </TrackNowButton>
          </Grid>
        </Grid>
        {activeFilters.length > 0 && (
          <Box sx={{ width: "100%", flexBasis: "100%", mt: 1 }}>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", width: "100%" }}>
              {activeFilters.map((filter) => (
                <Box
                  key={filter.id}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    backgroundColor: tokens.colors.offWhite,
                    border: "1px solid #ccc",
                    borderRadius: "20px",
                    px: 1.5,
                    py: 0.75,
                    fontSize: "13px",
                    color: "#333",
                  }}
                >
                  {`${formatFilterLabel(filter.field)} ${formatFilterCondition(filter)} : ${formatFilterValue(filter.value)}`}
                  <button
                    onClick={() => removeFilter(filter.id)}
                    style={{
                      marginLeft: "6px",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#666",
                      fontSize: "16px",
                      lineHeight: 1,
                    }}
                    type="button"
                  >
                    &times;
                  </button>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Grid>
    );
  };

  //const header = renderHeader();
  const cellListDisplayName = (rowData) => {
    return (
      <LightTooltip title={rowData.filingName} placement="bottom">
        <div
          onClick={() => {
            setSelectedMasters(rowData);
            props.changeSelectedMasters(rowData);
          }}
          style={{
            width: "12rem",
            margin: "0 1rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: primaryColor,
            cursor: "pointer",
            transition: "font-weight 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.fontWeight = '600';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.fontWeight = '400';
          }}
        >
          {rowData.filingName}
        </div>
      </LightTooltip>
    );
  };

  const cellListDisplayRuleInfo = (rowData) => {
    const ruleInfoValue = capitalizeLeadingText(rowData.ruleInfo);

    const strVal = String(ruleInfoValue);
    if (strVal.length > 25) {
      return (
        <LightTooltip title={ruleInfoValue} placement="bottom">
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {ruleInfoValue}
          </div>
        </LightTooltip>
      );
    }

    return (
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
      >
        {ruleInfoValue}
      </div>
    );
  };

  const cellWithTooltip = (rowData, field) => {
    const rawValue = rowData?.[field];
    const displayValue =
      typeof rawValue === "boolean"
        ? rawValue
          ? "True"
          : "False"
        : rawValue ?? "";

    const strVal = String(displayValue);
    if (strVal.length > 25) {
      return (
        <LightTooltip title={displayValue} placement="bottom">
          <div
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
          >
            {displayValue}
          </div>
        </LightTooltip>
      );
    }

    return (
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}
      >
        {displayValue}
      </div>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const rowElement = cellElement?.closest("tr");
    const rowIndexAttr = rowElement?.getAttribute("data-p-index");
    const rowIndex = rowIndexAttr !== null ? Number(rowIndexAttr) : -1;
    if (rowIndex >= 0 && rowIndex <= 2) {
      return "down";
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }

    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;

    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();

    const targetElement = event.currentTarget;
    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const CellListDisplayFederal = (rowData, field) => {
    let categories = rowData[field]
      ? String(rowData[field])
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
      : [];

    if (categories.length === 0 && Array.isArray(rowData[field])) {
      categories = rowData[field].filter(Boolean);
    }

    const hasValue = categories.length > 0;
    const hasMore = categories.length > 1;
    const primaryCategory = categories[0] || "";
    const remainingCount = Math.max(categories.length - 1, 0);

    const name =
      field === "federalCategories"
        ? "Who Must File Federal"
        : "Who Must File in State";
    const overlayKey = `${field}-${rowData.masterId || rowData.filingId || rowData.fileTrackingId}`;

    return (
      <div
        className='tableBtn'
        id={`${field}+${rowData.fileTrackingId}`}
        style={{ width: "inherit" }}
      >
        <button
          type='button'
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          style={{
            background: "transparent",
            border: "none",
            cursor: hasValue ? "pointer" : "default",
            width: "100%",
            padding: 0,
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: "inherit",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              color: primaryColor,
              fontWeight: 400,
            }}
          >
            {primaryCategory}
            {hasMore && (
              <span
                className='deferred-more-count'
                style={{
                  fontSize: "12px",
                  marginLeft: "6px",
                  color: "#9ca3af",
                }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            className='deferred-categories-overlay'
            showCloseIcon
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            {name}
            <div
              style={{
                width: "100%",
                maxWidth: "100%",
                maxHeight: "10.5rem",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "0.25rem",
                boxSizing: "border-box",
              }}
            >
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {categories.map((ele, idx) => (
                  <li
                    key={`${field}-${rowData.masterId || rowData.filingId}-${idx}`}
                    style={{ marginBottom: "4px" }}
                  >
                    {ele}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const toLocalTime = (date) => {
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-MMM-yyyy hh:mm:ss"),
        "dd-MMM-yyyy hh:mm:ss",
        { zone: "UTC" }
      )
        .toLocal()
        .toFormat("dd-MMM-yy");
      //  console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };
  const toLocalTime2 = (date) => {
    console.log("toLocalTime", date);
    if (date) {
      const _date = DateTime.fromFormat(
        DateTime.fromISO(date.toString()).toFormat("dd-LL-yyyy hh:mm:ss"),
        "dd-LL-yyyy hh:mm:ss",
        { zone: "UTC" }
      ).toFormat("yyyy-LL-dd");
      // console.log("@@@ LocalllTime:", _date);

      return _date;
    } else return "";
  };
  const handlePeriodChange = (e) => {
    console.log("handlePeriodChange", "e", e);
    if (e && e.value.length > 0) {
      const lastSelectedFilingPeriods = e.value[e.value.length - 1] // filtering the last selected filing periods
      // console.log("handlePeriodChange lastSelectedFilingPeriods", lastSelectedFilingPeriods, "updatedFilingMasterList", updatedFilingMasterList);
      const matchingFiling = updatedFilingMasterList.find(data => data.filingId === lastSelectedFilingPeriods.filingId)//selectimg a row based on selecting filing period

      const matchingFilingPeriod = e.value.filter(val => val.filingId === matchingFiling.filingId)// storing only selected row filing periods
      // console.log("handlePeriodChange matchingFilingPeriod", matchingFiling, "matchingFilingPeriod", matchingFilingPeriod);
      //Automatically selecting the row when respective periods is checked
      if (matchingFiling.isRejected) {
        //If filing is rejected then display all the filing periods 
        setSelectedPeriods(matchingFiling.filingPeriods)
        setSelectedMasters(matchingFiling)
      } else {
        setSelectedPeriods(matchingFilingPeriod)
        setSelectedMasters(matchingFiling)
      }
    } else {
      setSelectedPeriods(e.value)
      setSelectedMasters(null)
    }
  }
  const handleRowChange = (e) => {
    console.log("handleRowChange", "e", e);
    const selectedRow = e?.value || null;
    setSelectedMasters(selectedRow);

    if (selectedRow?.filingId) {
      setSelectedPeriods(
        Array.isArray(selectedRow.filingPeriods) ? selectedRow.filingPeriods : []
      );
    } else {
      setSelectedPeriods([]);
    }
  }

  useEffect(() => {
    console.log("useEffect - selectedPeriods:", selectedPeriods, "selectedMasters:", selectedMasters);
    props.changeSelectedPeriods(selectedPeriods || [])
    props.changeSelectedMasters(selectedMasters)
  }, [selectedPeriods, selectedMasters])
  console.log("selectedPeriods", selectedPeriods);

  const rowExpansionTemplate = (data) => {
    // console.log("rowExpansionTemplate", data.filingPeriods, "data", data);
    if (data.filingPeriods.length > 0) {
      let tableData = data.filingPeriods.map((ele) => {
        let startDate = new Date(ele.startDate);
        let endDate = new Date(ele.endDate);
        const toLocalDateString = date => {
          const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
          return date.toLocaleDateString('en-US', options).replace(/(\d+)\/(\d+)\/(\d+)/, (_, month, day, year) => `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`);
        };

        let fp = `${toLocalDateString(startDate)} - ${toLocalDateString(endDate)}`;
        let dueDate = ele.dueDate !== null ? toLocalDateString(new Date(ele.dueDate)) : null;
        return {
          periodId: ele.periodId,
          startDate: ele.startDate,
          endDate: ele.endDate,
          filingPeriod: fp,
          dueDate: dueDate,
          filingId: ele.filingId,
          fileTrackingId: ele.fileTrackingId !== null ? ele.fileTrackingId : [],
          workflowId: ele.workflowId !== null ? ele.workflowId : [],
        };
      });
      // console.log("rowExpansionTemplate tableData", tableData);

      return (
        <div className="filingPeriodTable p-3" style={{ width: "50vw" }}>
          <h5>Due Dates for {data.filingName}</h5>
          <DataTable
            value={tableData}
            selection={selectedPeriods}
            onSelectionChange={(e) => handlePeriodChange({ value: e.value })}
            dataKey="periodId"
            selectionMode="checkbox"
            emptyMessage="No periods available"
            style={{ fontSize: '15px' }}
          >
            <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
            <Column field="filingPeriod" header="Filing Period" style={{ width: '300px', padding: '4px 8px' }} />
            <Column field="dueDate" header="Due Date" style={{ width: '150px', padding: '4px 8px' }} body={(rowData) => rowData.dueDate || ''} />
          </DataTable>
        </div>
      );
    } else {
      return (
        <div className="filingPeriodTable p-3">
          <h5>No Due Dates for {data.filingName}</h5>
        </div>
      );
    }
  };
  const isRowExpanded = (rowData) => {
    if (!expandedRows || !rowData) return false;

    if (Array.isArray(expandedRows)) {
      return expandedRows.some((row) => row?.filingId === rowData.filingId);
    }

    if (typeof expandedRows === "object") {
      return Object.prototype.hasOwnProperty.call(
        expandedRows,
        rowData.filingId
      );
    }

    return false;
  };

  const toggleExpandedRow = (rowData) => {
    if (isRowExpanded(rowData)) {
      setExpandedRows(null);
      return;
    }

    setExpandedRows({ [rowData.filingId]: true });
  };

  const expanderBodyTemplate = (rowData) => {
    const expanded = isRowExpanded(rowData);

    return (
      <button
        type="button"
        className="deferred-row-expander"
        aria-label={expanded ? "Collapse row" : "Expand row"}
        aria-expanded={expanded}
        onClick={(event) => {
          event.stopPropagation();
          toggleExpandedRow(rowData);
        }}
      >
        <GoogleMaterialIcon
          name={expanded ? "keyboard_arrow_down" : "keyboard_arrow_right"}
          size={20}
          color={primaryColor}
        />
      </button>
    );
  };

  const jusrisdictionItemTemplate = (option) => {
    // console.log("##TOptions:", option);
    return (
      <div className='flex align-items-center'>
        <span>{option}</span>
      </div>
    );
  };

  const jusrisdictionArray = ["Federal", "State", "Both"];

  const jurisdictionRowFilterTemplate = (options) => {
    // console.log("jurisdictionRowFilterTemplate props", options,masterCatFilter);

    if (!masterCatFilter.jurisdiction && options.filterModel.value) {
      options.filterModel.value = null;
      options.value = null;
    }

    return (
      <Dropdown
        value={masterCatFilter.jurisdiction || []}
        options={jusrisdictionArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##EOptions:", e);
          setMasterCatFilter((prev) => {
            return { ...prev, jurisdiction: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const requiredArray = ["True", "False"];

  const requiredRowFilterTemplate = (options) => {
    // console.log("requiredRowFilterTemplate:", options,masterCatFilter);
    if (!masterCatFilter.required && options.filterModel.value) {
      options.filterModel.value = null;
      options.value = null;
    }
    return (
      <Dropdown
        value={masterCatFilter.required || []}
        options={requiredArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, required: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const masterCategoryFilter = (options, field) => {
    // console.log("OPTIONCHECK", options, "field", field);
    return options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter[field] || []}
        options={categoryList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, [field]: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const stateRowFilterTemplate = (options) => {
    if (!masterCatFilter.stateList && options.filterModel.value) {
      options.filterModel.value = [];
      options.value = [];
    }
    return options.filterModel.matchMode === "contains" ? (
      <MultiSelect
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          options.filterCallback(e.value, options.index);
        }}
        placeholder="Any"
        maxSelectedLabels={1}
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    ) : (
      <Dropdown
        value={masterCatFilter.stateList || []}
        options={stateArray}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setMasterCatFilter((prev) => {
            return { ...prev, stateList: e.value };
          });
          let values = [];
          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder="Any"
        className="p-column-filter"
        style={{ minWidth: "12rem", maxWidth: "12rem" }}
      />
    );
  };

  const dt = useRef(null);
  const pageSize = 100;

  const getDeferredTableScroller = () => {
    return (
      dt.current?.getElement?.()?.querySelector?.(".p-datatable-wrapper") ||
      document.querySelector(".frozen-deffered .p-datatable-wrapper")
    );
  };

  useEffect(() => {
    filingsLengthRef.current = updatedFilingMasterList.length;
  }, [updatedFilingMasterList.length]);

  const handleTableScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    console.log('Scroll event:', { scrollTop, scrollHeight, clientHeight });

    const isNearBottom = scrollTop + clientHeight >= scrollHeight - 50;
    const isNearTop = scrollTop < 50;

    const currentLazyLoading = lazyLoadingRef.current;
    const currentWindowStart = windowStartRef.current;
    const currentTotalRecords = totalRecordsRef.current;
    const currentFilingsLength = filingsLengthRef.current;

    console.log('Scroll check:', {
      isNearBottom,
      isNearTop,
      currentLazyLoading,
      currentWindowStart,
      currentFilingsLength,
      currentTotalRecords
    });

    // Scroll down - load next batch
    if (isNearBottom && !currentLazyLoading && currentWindowStart + currentFilingsLength < currentTotalRecords) {
      console.log('Loading next batch');
      lazyLoadingRef.current = true;
      lastScrollDirectionRef.current = "down";
      const newStart = currentWindowStart + 100;
      loadRecordsWindow(newStart);
    }
    // Scroll up - load previous batch
    else if (isNearTop && !currentLazyLoading && currentWindowStart > 0) {
      console.log('Loading previous batch');
      lazyLoadingRef.current = true;
      lastScrollDirectionRef.current = "up";
      const newStart = Math.max(0, currentWindowStart - 100);
      loadRecordsWindow(newStart);
    }
  };

  useEffect(() => {
    const scroller = getDeferredTableScroller();
    if (!scroller) {
      return undefined;
    }

    const onScroll = (event) => handleTableScroll(event);
    scroller.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      scroller.removeEventListener("scroll", onScroll);
    };
  }, [updatedFilingMasterList.length, selectedCustomer?.customerId]);



  const loadRecordsWindow = async (windowStart) => {
    console.log("loadRecordsWindow", windowStart);
    setLazyLoading(true);

    const windowSize = 100;
    const first = windowStart;
    const last = windowStart + windowSize;

    let url = `${API_BASE_URL}/Customer/BusinessBasedFilingMasterListbyPagination?StartRow=${first + 1}&EndRow=${last}&CustomerId=${_clientId}`

    let filingType
    if (clientTypeVal !== masterTypeVal) {
      filingType = clientTypeVal ? "ClientFiling" : "MasterFiling"
    }
    if (filingType) {
      url = `${url}&FilingType=${filingType}`
    }

    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      isFilterChange.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal
          ? encodeURIComponent(ele.searchTypeVal)
          : "";
        url = `${url}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``}`;
      });
    }

    if (sortingData && typeof sortingData === "object" && sortingData.sortBy !== "" && sortingData.sortOrder !== "") {
      let sortParameter = getSortData(sortingData.sortBy);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";
      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    console.log("loadRecordsWindow url", url);
    try {
      const res = await axios.get(url);
      console.log("loadRecordsWindow res", res.data);

      if (res.data && res.data.items) {
        setTotalRecords(res.data.totalItems);
        totalRecordsRef.current = res.data.totalItems;

        const filteredItems = applyRequiredFilterOnRows(res.data.items);
        const updList = filteredItems
          .map((item) => mapDeferredRecordForDisplay(item))
          .filter(Boolean);

        setUpdatedFilingMasterList(updList);
        setCurrentWindowStart(windowStart);
        windowStartRef.current = windowStart;
        filingsLengthRef.current = updList.length;

        requestAnimationFrame(() => {
          const scroller = getDeferredTableScroller();
          if (!scroller) {
            return;
          }

          if (lastScrollDirectionRef.current === "down") {
            scroller.scrollTop = Math.max(0, scroller.scrollHeight * 0.35);
          } else if (lastScrollDirectionRef.current === "up") {
            scroller.scrollTop = Math.max(0, scroller.scrollHeight * 0.55);
          }
          lastScrollDirectionRef.current = null;
        });

        if (isFilterChange && isFilterChange.length <= 0 && sortingData && sortingData.sortBy === "") {
          if (clientTypeVal === masterTypeVal) {
            setClientTypeVal(res.data.isClientFile)
            setMasterTypeVal(res.data.isMasterFile)
            if (res.data.isClientFile === true && res.data.isMasterFile === true) {
              setIsFilingTypeDisabled(false)
            } else {
              setIsFilingTypeDisabled(true)
            }
          }
          setIsFilingTypeChanged(false)
        }

        setLazyLoading(false);
        lazyLoadingRef.current = false;
        return updList;
      } else {
        setLazyLoading(false);
        lazyLoadingRef.current = false;
        return [];
      }
    } catch (err) {
      console.log("loadRecordsWindow err", err);
      setLazyLoading(false);
      lazyLoadingRef.current = false;
      return [];
    }
  };

  const loadRecordsList = async (first, last) => {
    console.log("loadRecordsList props", first, last);

    if (first === 0) {
      setIsLoading(true);
    } else {
      setLazyLoading(true);
    }

    let url = `${API_BASE_URL}/Customer/BusinessBasedFilingMasterListbyPagination?StartRow=${first + 1}&EndRow=${last}&CustomerId=${_clientId}`

    let filingType
    if (clientTypeVal !== masterTypeVal) {
      filingType = clientTypeVal ? "ClientFiling" : "MasterFiling"
    }
    if (filingType) {
      url = `${url}&FilingType=${filingType}`
    }

    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      isFilterChange.forEach((ele) => {
        const filterName = encodeURIComponent(ele.name);
        const filterValue = encodeURIComponent(ele.val);
        const searchType = ele.searchType ? encodeURIComponent(ele.searchType) : "";
        const searchTypeVal = ele.searchTypeVal
          ? encodeURIComponent(ele.searchTypeVal)
          : "";
        url = `${url}&${filterName}=${filterValue}${ele.searchType ? `&${searchType}=${searchTypeVal}` : ``
          }`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      let sortParameter = getSortData(sortingData.sortBy);
      console.log("getSortData", sortParameter);
      let order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";

      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    console.log("loadRecordsList url", url);
    try {
      const res = await axios.get(url);
      console.log("loadRecordsList res", res.data);

      if (res.data && res.data.items) {
        setTotalRecords(res.data.totalItems);
        totalRecordsRef.current = res.data.totalItems;

        const filteredItems = applyRequiredFilterOnRows(res.data.items);
        const updList = filteredItems
          .map((item) => mapDeferredRecordForDisplay(item))
          .filter(Boolean);

        setUpdatedFilingMasterList(updList);
        setCurrentWindowStart(0);
        windowStartRef.current = 0;
        filingsLengthRef.current = updList.length;
        hasMoreDataRef.current = updList.length < res.data.totalItems;

        if (isFilterChange && isFilterChange.length <= 0 &&
          sortingData && sortingData.sortBy === "") {

          if (clientTypeVal === masterTypeVal) {
            setClientTypeVal(res.data.isClientFile)
            setMasterTypeVal(res.data.isMasterFile)
            if (res.data.isClientFile === true && res.data.isMasterFile === true) {
              setIsFilingTypeDisabled(false)
            } else {
              setIsFilingTypeDisabled(true)
            }
          }
          setIsFilingTypeChanged(false)
        }

        setIsLoading(false);
        setLazyLoading(false);
        lazyLoadingRef.current = false;
        return updList;
      } else {
        setIsLoading(false);
        setLazyLoading(false);
        lazyLoadingRef.current = false;
        return [];
      }
    } catch (err) {
      console.log("loadRecordsList err", err);
      setIsLoading(false);
      setLazyLoading(false);
      lazyLoadingRef.current = false;
      return [];
    }
  };



  const getStateName = (stateCode) => {
    if (stateCode !== null) {
      const state = states.find((s) => s.code === stateCode);
      const stateName = state ? state.state : stateCode;
      return stateName;
    }
    return null
  };

  //table filter change
  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];

    const getConstraintValue = (col) => e?.filters?.[col]?.constraints?.[0]?.value;
    const getConstraintMatchMode = (col) => e?.filters?.[col]?.constraints?.[0]?.matchMode;

    const getValueList = (value) =>
      (Array.isArray(value) ? value : [value]).filter(
        (item) => item !== null && item !== undefined && item !== ""
      );

    const pushMultiValueFilters = ({
      name,
      searchType,
      values,
      matchMode,
      transformValue = (value) => value,
    }) => {
      const normalizedValues = getValueList(values);
      normalizedValues.forEach((rawValue, index) => {
        const changeItem = {
          name,
          val: transformValue(rawValue),
        };
        if (index + 1 === normalizedValues.length && searchType) {
          changeItem.searchType = searchType;
          changeItem.searchTypeVal = getSearchType(matchMode);
        }
        filterChange.push(changeItem);
      });
    };

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByFilingName`,
        val: e.filters.global.value,
        searchType: `FilingNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        console.log("onFilterChange col", col, e.filters[col]);
        if (
          e.filters[col].constraints &&
          e.filters[col].constraints[0].value !== null
        ) {
          if (col === "stateList") {
            const stateValue = getConstraintValue(col);
            const stateMode = getConstraintMatchMode(col);
            Array.isArray(stateValue)
              ? pushMultiValueFilters({
                name: `SearchByStateInfo`,
                searchType: `StateInfoSearchType`,
                values: stateValue,
                matchMode: stateMode,
                transformValue: (value) => getStateCode(value),
              })
              : filterChange.push({
                name: `SearchByState`,
                val: getStateCode(stateValue),
                searchType: `StateSearchType`,
                searchTypeVal: getSearchType(stateMode),
              });
          } else if (col === "juristiction") {
            filterChange.push({
              name: `SearchByJuristiction`,
              val: getConstraintValue(col),
            });
          } else if (col === "required") {
            filterChange.push({
              name: `SearchByRequired`,
              val: getConstraintValue(col),
            });
          } else if (col === "filingName") {
            filterChange.push({
              name: `SearchByFilingName`,
              val: getConstraintValue(col),
              searchType: `FilingNameSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "filingFrequency") {
            pushMultiValueFilters({
              name: `SearchByFilingFrequency`,
              searchType: `FilingFrequencySearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "ruleInfo") {
            filterChange.push({
              name: `SearchByRuleInfo`,
              val: normalizeRuleInfoFilterValue(getConstraintValue(col)),
              searchType: `RuleInfoSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "jsicontactName") {
            filterChange.push({
              name: `SearchByJSIStaff`,
              val: getConstraintValue(col),
              searchType: `JSIStaffSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "dueDate") {
            filterChange.push({
              name: `SearchByDueDate`,
              val: formatFilterDate(getConstraintValue(col)),
              searchType: `DueDateSearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          } else if (col === "federalCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileFederal`,
              searchType: `WhoMustFileFederalSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else if (col === "stateCategories") {
            pushMultiValueFilters({
              name: `WhoMustFileInState`,
              searchType: `WhoMustFileInStateSearchType`,
              values: getConstraintValue(col),
              matchMode: getConstraintMatchMode(col),
            });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: getConstraintValue(col),
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(getConstraintMatchMode(col)),
            });
          }
        }
      });
    }

    //set filter
    console.log("onFilterChange filterChange", filterChange);
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const normalizeRuleInfoFilterValue = (value) => {
    if (typeof value !== "string") {
      return value;
    }
    const rawValue = value.trim();
    if (!rawValue) {
      return rawValue;
    }

    return rawValue
      .split(/\s+/)
      .map((word) => {
        if (/^[a-z]{1,4}$/.test(word)) {
          return word.toUpperCase();
        }
        if (/^[a-z]/.test(word)) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word;
      })
      .join(" ");
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    const match = matchModeVal.find((ele) => ele.name === matchMode);
    return match ? match.val : "Contains";
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "dueDate") {
      return {
        SortByParameter: "SortByDuedate",
        SortByVal: "DueDate",
        SortOrderParameter: "SortOrderDuedate"
      }
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "StateInfo",
        SortOrderParameter: "SortOrder"
      }
    } else if (val === "federalCategories" || val === "stateCategories") {
      return {
        SortByParameter: "SortByBusinessCategory",
        SortByVal: "BusinessCategory",
        SortOrderParameter: "SortOrderBusinessCategory"
      }
    } else {
      return {
        SortByParameter: `SortBy`,
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: `SortOrder`
      }
    }
  }

  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
  };

  //table sort change
  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
    }
  }

  useEffect(() => {
    const filterChanged = JSON.stringify(prevFilterRef.current) !== JSON.stringify(isFilterChange);
    const sortChanged = JSON.stringify(prevSortRef.current) !== JSON.stringify(sortingData);

    console.log("filter/sort change", { filterChanged, sortChanged, isFilterChange, sortingData });

    if (initialLoadRef.current && (filterChanged || sortChanged)) {
      prevFilterRef.current = isFilterChange;
      prevSortRef.current = sortingData;

      const sortAndFilterApiCall = async () => {
        console.log("LOAD Check - filter/sort");
        setUpdatedFilingMasterList([]);
        setIsLoading(true);
        filingsLengthRef.current = 0;
        hasMoreDataRef.current = true;
        lazyLoadingRef.current = false;
        windowStartRef.current = 0;
        setCurrentWindowStart(0);
        await loadRecordsList(0, 100);
      };

      const timeoutId = setTimeout(() => {
        sortAndFilterApiCall();
      }, 300);

      return () => clearTimeout(timeoutId);
    }
  }, [isFilterChange, sortingData]);



  useEffect(() => {
    console.log("Total Records updated:", totalRecords);
  }, [totalRecords]);

  useEffect(() => {
    console.log("pendingTableData,", updatedFilingMasterList);
  }, [
    updatedFilingMasterList,
    updatedFilingMasterList.length,
    JSON.stringify(updatedFilingMasterList),
  ]);

  useEffect(() => {
    console.log("isLoading", isLoading);
  }, [isLoading]);

  useEffect(() => {
    console.log("lazyLoading", lazyLoading);
  }, [lazyLoading]);
  
  useEffect(() => {
    console.log("clientScopedBranding DF", clientScopedBranding);
  }, [clientScopedBranding]);


  const visibleFilingMasterList = (() => {
    const requiredFilter = (activeFilters || []).find(
      (filter) => filter.field === "required"
    );

    if (!requiredFilter) {
      return updatedFilingMasterList;
    }

    const expectedValue = normalizeRequiredFilterValue(requiredFilter.value);
    if (typeof expectedValue !== "boolean") {
      return updatedFilingMasterList;
    }

    return (updatedFilingMasterList || []).filter((item) => {
      const rowValue = normalizeRequiredRecordValue(item?.required);
      return rowValue === expectedValue;
    });
  })();


  return (
    <Fragment>


      {isLoading && (
        <Loader />
      )}

      <div style={{ padding: "0 1px 12px" }}>
        <DataTable
          ref={dt}
          value={visibleFilingMasterList}
          emptyMessage='No records found'
          scrollable
          scrollHeight="550px"
          className="frozen-deffered"
          style={{ borderRadius: '8px', overflow: 'hidden', border: 'none', minHeight: '50vh', background: tokens.colors.offWhite, width: "100%" }}
          selectionMode="radiobutton"
          selection={selectedMasters}
          onSelectionChange={(e) => handleRowChange(e)}
          expandedRows={expandedRows}
          rowExpansionTemplate={rowExpansionTemplate}
          dataKey='filingId'
          header={renderHeader()}
          sortField={sortingData.sortBy}
          sortOrder={sortingData.sortOrder}
          onSort={(e) => handleSort(e)}
        >
          <Column
            frozen={enableForzen}
            body={expanderBodyTemplate}
            style={{ width: '3rem' }}
          />
          <Column selectionMode="single" frozen={enableForzen} headerStyle={{ width: "3rem" }} />

          <Column
            field='filingName'
            header='Filing Name'
            frozen={enableForzen}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            className="filingNameColumn"
            style={{ minWidth: "12rem", maxWidth: "25rem" }}
            body={(rowData) => cellListDisplayName(rowData)}
          />

          <Column
            field='filingFrequency'
            header='Filing Frequency'
            frozen={enableForzen}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            style={{ minWidth: "15rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'filingFrequency')}
          />

          <Column
            field='stateList'
            header='State'
            frozen={enableForzen}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            style={{ minWidth: "13rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'stateList')}
          />

          <Column
            field='ruleInfo'
            header='Rule Info'
            style={{ minWidth: "15rem", maxWidth: "15rem" }}
            body={(rowData) => cellListDisplayRuleInfo(rowData)}
          />

          <Column
            field="federalCategories"
            header="Who Must File in Federal"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            className="deferred-federal-column"
            bodyClassName="deferred-federal-column"
            body={(rowData) => CellListDisplayFederal(rowData, "federalCategories")}
          />

          <Column
            field="stateCategories"
            header="Who Must File in State"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            className="deferred-state-column"
            bodyClassName="deferred-state-column"
            body={(rowData) => CellListDisplayFederal(rowData, "stateCategories")}
          />

          <Column
            field="juristiction"
            header="Jurisdiction"
            style={{ minWidth: "14rem" }}
            sortable
            sortIcon={(options) => {
              if (options.sorted) {
                return options.sortOrder === 1 ? (
                  <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
                ) : (
                  <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
                );
              }
              return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
            }}
            body={(rowData) => cellWithTooltip(rowData, 'juristiction')}
          />

          <Column
            field='required'
            header='Required'
            style={{ minWidth: "13rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'required')}
          />

          <Column
            field="jsicontactName"
            header="JSI Staff"
            style={{ minWidth: "18rem", maxWidth: "18rem" }}
            body={(rowData) => cellWithTooltip(rowData, 'jsicontactName')}
          />
        </DataTable>
      </div>

      <ClientTableFilter
        anchorEl={filterAnchorEl}
        onClose={handleFilterClose}
        onApply={handleFilterApply}
        onClear={handleFilterClear}
        clients={updatedFilingMasterList}
        categoriesLookup={categoryList}
        programList={[]}
        stateList={stateArray}
        tracknowlicenseTypes={[]}
        postawardlicenseTypes={[]}
        roleType={roleType}
        filingMasterMode={false}
        trackNowDeferredMode={true}
        requiredOnlyIs={true}
      />

      <CustomDialog
        header='Confirmation'
        visible={showAlert}
        onHide={() => closeAlert()}
        onConfirm={() => submitHandler()}
        confirmLabel='Yes'
        cancelLabel='No'
      >
        {alertMessage}
      </CustomDialog>
      <style>{`
  .frozen-deffered .p-datatable.frozen-deffered {
    border-radius: 8px !important;
    overflow: hidden !important;
    border: none !important;
    box-shadow: none !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-deffered .p-datatable-wrapper {
    border-radius: 8px !important;
    overflow: hidden !important;
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-deffered .p-datatable-header {
    background: ${tokens.colors.offWhite} !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .frozen-deffered .p-datatable-header > * {
    background: ${tokens.colors.offWhite} !important;
  }

  .frozen-deffered .p-datatable-table {
    border-radius: 8px !important;
    border-collapse: separate !important;
    border-spacing: 0 !important;
  }

  /* HEADER */
  .frozen-deffered .p-datatable-thead {
    position: sticky !important;
    top: 0 !important;
    z-index: 3 !important;
  }

  .frozen-deffered .p-datatable-thead > tr {
    background: linear-gradient(90deg, #2d1744 0%, #5b2ba8 100%) !important;
  }

  .frozen-deffered .p-datatable-thead > tr:first-child > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-deffered .p-datatable-thead > tr:first-child > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:last-child > td:first-child {
    border-bottom-left-radius: 8px !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:last-child > td:last-child {
    border-bottom-right-radius: 8px !important;
  }

  .frozen-deffered .p-datatable-thead > tr > th {
    background: ${primaryColor} !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 10px 12px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
    overflow: hidden !important;
    height: 36px !important;
    min-height: 36px !important;
    max-height: 36px !important;
  }

  .frozen-deffered .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  /* Frozen columns z-index fix and dark purple background */
  .frozen-deffered .p-datatable-thead > tr > th.p-frozen-column {
    z-index: 2 !important;
    background: ${primaryColor} !important;
    will-change: auto !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tokens.colors.white} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
    z-index: 1 !important;
    background: ${tokens.colors.offWhite} !important;
    color: #000000 !important;
    will-change: auto !important;
  }

  .frozen-deffered .p-datatable-tbody > tr > td.p-frozen-column:hover {
    background-color: inherit !important;
    font-weight: inherit !important;
    color: inherit !important;
  }

  .frozen-deffered .p-sortable-column-icon {
    color: #ffffff !important;
  }

  .frozen-deffered .deferred-row-expander {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 28px !important;
    height: 28px !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 999px !important;
    background: transparent !important;
    cursor: pointer !important;
  }

  .frozen-deffered .deferred-row-expander:hover,
  .frozen-deffered .deferred-row-expander:focus-visible {
    background: transparent !important;
    outline: none !important;
    cursor: pointer !important;
  }

  .frozen-deffered .deferred-row-expander *,
  .frozen-deffered .deferred-row-expander svg,
  .frozen-deffered .p-datatable-tbody > tr > td.p-frozen-column:first-child:hover,
  .frozen-deffered .p-datatable-tbody > tr > td.p-frozen-column:has(.deferred-row-expander):hover {
    cursor: pointer !important;
  }

  /* ROWS - Match ApprovalList row height */
  .frozen-deffered .p-datatable-tbody > tr:not(.p-datatable-row-expansion) {
    height: 28px !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:nth-child(odd):not(.p-datatable-row-expansion) > td {
    background-color: ${tokens.colors.white} !important;
    padding: 4px 8px !important;
    font-size: 15px !important;
    line-height: 1.3 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    box-sizing: border-box !important;
  }

  .frozen-deffered .p-datatable-tbody > tr:nth-child(even):not(.p-datatable-row-expansion) > td {
    background-color: ${tokens.colors.offWhite} !important;
    padding: 4px 8px !important;
    font-size: 15px !important;
    line-height: 1.3 !important;
    color: #000000 !important;
    font-family: Area Normal, Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    height: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    box-sizing: border-box !important;
  }

  /* FORCE DYNAMIC PRIMARY COLOR BORDERS ON ALL CELLS - MUST BE LAST */
  .frozen-deffered .p-datatable-tbody > tr > td {
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
    border-left: none !important;
    border-top: none !important;
    empty-cells: show !important;
  }

  .frozen-deffered .p-datatable-tbody > tr > td:last-child {
    border-right: none !important;
  }

  /* Hover handled inline on the value span */

  .deferred-categories-overlay {
    z-index: 1100 !important;
    width: min(22rem, calc(100vw - 1rem)) !important;
    max-width: min(22rem, calc(100vw - 1rem)) !important;
    max-height: min(18rem, calc(100vh - 1rem)) !important;
    background: ${tokens.colors.offWhite} !important;
    border: 1px solid #C0BEC2 !important;
    overflow: visible !important;
    box-sizing: border-box !important;
  }

  .deferred-categories-overlay:after {
    border-style: solid !important;
    border-color: transparent !important;
    border-bottom-color: ${tokens.colors.offWhite} !important;
  }

  .deferred-categories-overlay:before {
    border-style: solid !important;
    border-color: transparent !important;
    border-bottom-color: #C0BEC2 !important;
  }

  .deferred-categories-overlay.p-overlaypanel-flipped:after {
    border-bottom-color: transparent !important;
    border-top-color: ${tokens.colors.offWhite} !important;
  }

  .deferred-categories-overlay.p-overlaypanel-flipped:before {
    border-bottom-color: transparent !important;
    border-top-color: #C0BEC2 !important;
  }

  .deferred-categories-overlay .p-overlaypanel-content {
    padding: 1.5rem 1rem 1rem 1rem !important;
    background: ${tokens.colors.offWhite} !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }

  .deferred-categories-overlay ul {
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .deferred-overlay-scroll {
    width: 100%;
    max-width: 100%;
    max-height: min(10.5rem, calc(100vh - 6rem));
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 0.25rem;
    box-sizing: border-box;
  }

  .deferred-overlay-scroll::-webkit-scrollbar {
    width: 8px;
  }

  .deferred-overlay-scroll::-webkit-scrollbar-track {
    background: transparent;
  }

  .deferred-overlay-scroll::-webkit-scrollbar-thumb {
    background: #b9bbbd;
    border-radius: 10px;
  }

  .deferred-overlay-scroll::-webkit-scrollbar-thumb:hover {
    background: ${primaryColor};
  }

  .deferred-categories-overlay .p-overlaypanel-close {
    background: ${primaryColor} !important;
    border: none !important;
    border-radius: 999px !important;
    width: 1.6rem !important;
    height: 1.6rem !important;
    color: #ffffff !important;
    position: absolute !important;
    top: 0.35rem !important;
    right: 0.35rem !important;
    margin: 0 !important;
    z-index: 2 !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .deferred-categories-overlay .p-overlaypanel-close:hover {
    background: ${primaryColor} !important;
    filter: brightness(1.08);
  }

  .deferred-categories-overlay .p-overlaypanel-close-icon,
  .deferred-categories-overlay .p-overlaypanel-close .pi,
  .deferred-categories-overlay .p-overlaypanel-close svg {
    color: #ffffff !important;
    fill: #ffffff !important;
  }

  .frozen-deffered .deferred-more-count {
    color: #9ca3af !important;
    font-size: 12px !important;
    margin-left: 6px !important;
    text-decoration: none !important;
  }

.frozen-deffered .p-datatable-tbody > tr > td.filingNameColumn {
  color: ${primaryColor} !important;
}

.frozen-deffered .p-datatable-tbody > tr > td.filingNameColumn * {
  color: ${primaryColor} !important;
}

/* Values in Filing Name, Who Must File in Federal, and Who Must File in State columns become bold and alpha background on hover */
.frozen-deffered .p-datatable-tbody > tr > td.filingNameColumn:hover,
.frozen-deffered .p-datatable-tbody > tr > td.deferred-federal-column:hover,
.frozen-deffered .p-datatable-tbody > tr > td.deferred-state-column:hover {
  background-color: color-mix(in srgb, ${primaryColor} 8%, white) !important;
  cursor: pointer !important;
}

.frozen-deffered .p-datatable-tbody > tr > td.filingNameColumn:hover *,
.frozen-deffered .p-datatable-tbody > tr > td.deferred-federal-column:hover *,
.frozen-deffered .p-datatable-tbody > tr > td.deferred-state-column:hover * {
  font-weight: 600 !important;
  color: ${primaryColor} !important;
}

/* All other columns MUST NOT change background, cursor, or font-weight on hover */
.frozen-deffered .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td:not(.filingNameColumn):not(.deferred-federal-column):not(.deferred-state-column):not(.p-frozen-column):hover {
  background-color: inherit !important;
  cursor: default !important;
}

.frozen-deffered .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td:not(.filingNameColumn):not(.deferred-federal-column):not(.deferred-state-column):not(.p-frozen-column):hover * {
  font-weight: inherit !important;
  color: inherit !important;
}

  /* Expanded row nested table (Filing Period / Due Date) - match ApprovalList styling (no hover color shift) */
  .frozen-deffered .filingPeriodTable .p-datatable {
    border-radius: 8px !important;
    overflow: hidden !important;
  }

  /* Force stable (non-hover) body text color so it doesn't flip on hover */
  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr > td {
    color: #000000 !important;
    font-weight: 400 !important;
    background-color: inherit !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr > td * {
    color: #000000 !important;
    font-weight: 400 !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th {
    background: ${primaryColor} !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    letter-spacing: 0.02em !important;
    padding: 12px 16px !important;
    border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-bottom: none !important;
    text-transform: none !important;
    box-shadow: none !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th *,
  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th .p-column-title {
    color: #ffffff !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th:last-child {
    border-right: none !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th:first-child {
    border-top-left-radius: 8px !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th:last-child {
    border-top-right-radius: 8px !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr:hover {
    background: ${primaryColor} !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr:hover > th,
  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr:hover > th * {
    color: #ffffff !important;
    background: ${primaryColor} !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr > td:hover {
    background-color: inherit !important;
    color: #000000 !important;
    font-weight: 400 !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr > td:hover * {
    color: #000000 !important;
    font-weight: 400 !important;
  }

  /* Some PrimeReact themes apply hover on the row; neutralize that too. */
  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr:hover > td,
  .frozen-deffered .filingPeriodTable .p-datatable-tbody > tr:hover > td * {
    background-color: inherit !important;
    color: #000000 !important;
    font-weight: 400 !important;
  }

  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th:hover,
  .frozen-deffered .filingPeriodTable .p-datatable-thead > tr > th:hover * {
    color: #ffffff !important;
    background: ${primaryColor} !important;
  }

  /* SELECTED ROW */
  .frozen-deffered .p-datatable-tbody > tr.p-highlight:nth-child(odd):not(.p-datatable-row-expansion) > td,
  .frozen-deffered .p-datatable-tbody > tr.p-highlight:nth-child(even):not(.p-datatable-row-expansion) > td,
  .frozen-deffered .p-datatable-tbody > tr.p-highlight:nth-child(odd):not(.p-datatable-row-expansion) > td.p-frozen-column,
  .frozen-deffered .p-datatable-tbody > tr.p-highlight:nth-child(even):not(.p-datatable-row-expansion) > td.p-frozen-column {
    background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
    border-right: 1px solid ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
  }

  .frozen-deffered .p-selection-column,
  .frozen-deffered .filingPeriodTable .p-selection-column {
    text-align: center !important;
  }

  .frozen-deffered .p-selection-column .p-radiobutton,
  .frozen-deffered .filingPeriodTable .p-selection-column .p-checkbox {
    display: flex !important;
    justify-content: center !important;
    margin: 0 auto !important;
  }

  .frozen-deffered .p-selection-column .p-radiobutton .p-radiobutton-box {
    border: 2px solid ${primaryColor} !important;
  }
  .frozen-deffered .p-selection-column .p-radiobutton .p-radiobutton-box.p-highlight,
  .p-radiobutton .p-radiobutton-box.p-highlight {
    border-color: ${primaryColor} !important;
    background: ${primaryColor} !important;
  }
  .frozen-deffered .p-selection-column .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover {
    border-color: ${primaryColor} !important;
  }

  .frozen-deffered .filingPeriodTable .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover,
  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-focus,
  .frozen-deffered .filingPeriodTable .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:focus {
    border-color: ${primaryColor} !important;
    box-shadow: 0 0 0 0.2rem color-mix(in srgb, ${primaryColor} 25%, transparent) !important;
  }

  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-highlight {
    background: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
  }

  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-highlight:hover {
    background: ${primaryColor} !important;
    border-color: ${primaryColor} !important;
  }

  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-highlight .p-checkbox-icon,
  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-highlight .p-icon,
  .frozen-deffered .filingPeriodTable .p-checkbox .p-checkbox-box.p-highlight svg {
    color: #ffffff !important;
    fill: #ffffff !important;
    stroke: #ffffff !important;
    stroke-width: 1 !important;
    font-size: 0.7rem !important;
    font-weight: 100 !important;
  }

  /* SCROLLBAR */
  .frozen-deffered .p-datatable-wrapper {
    overflow: auto !important;
    max-height: 550px !important;
  }

  .frozen-deffered .p-datatable-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .frozen-deffered .p-datatable-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .frozen-deffered .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background: #C0BEC2;
    border-radius: 10px;
  }

  .frozen-deffered .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
    background: ${primaryColor};
  }

  .frozen-deffered .p-datatable-wrapper::-webkit-scrollbar-corner {
    background: #f1f1f1;
  }

  /* Tooltip for frozen columns */
  .frozen-deffered .p-datatable-tbody > tr > td.p-frozen-column {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
`}
      </style>
      <CustomDialog
        header={dialogTitle}
        visible={openDialog}
        onHide={() => setOpenDialog(false)}
      >
        {dialogMessage}
      </CustomDialog>
    </Fragment>
  );
};

export default AddFilingTable;
